import Swal from 'sweetalert2';

export const alertaError = (mensaje) => {
  Swal.fire({
    icon: 'error',
    title: 'Error',
    text: mensaje,
    confirmButtonText: 'Aceptar'
  });
};

export const alertaSuccess = (mensaje) => {
  Swal.fire({
    icon: 'success',
    title: 'Éxito',
    text: mensaje,
    confirmButtonText: 'Aceptar'
  });
};
